import type { SearchQuotaDto } from "app/pages/sales-intelligence/modules/leads-search";
import type { IFetchService } from "app/services/fetchService";

import type { SavedSearchDto } from "../../types/dto";

/**
 * @deprecated use leads-search or saved-search API service instead
 */
const createAdvancedSearchApiService = (fetchService: IFetchService) => {
    return {
        updateSearchNameById(id: string, name: SavedSearchDto["name"]): Promise<void> {
            return fetchService.put(`/sales-api/save-search/v2/searches/${id}/update/name`, {
                name,
            });
        },
        deleteSearchById(id: string): Promise<Response> {
            return fetchService.delete(`/sales-api/save-search/v2/searches/${id}`);
        },

        fetchSearchQuota(): Promise<SearchQuotaDto> {
            return fetchService.get("/sales-api/leads-generator/v2/leads/search-quota");
        },
    };
};

export default createAdvancedSearchApiService;
